<template>
   <!-- 全局提示框 -->
   <div class="disalog-wrapper" v-show="visible" id="dialogtips">
       <div v-show="visible" class="dialog-tips dialog-center">
            <div class="msg">{{message}}</div>
            <div class="confirm-btn" @click.prevent="close">确定</div>
        </div>
   </div>
   
</template>
<script>
export default {
 data() {
    return {
        visible: false,
        message: ""
    };
 },
 methods:{
    close(){
        this.visible = false;
    }
 }
};
</script>
<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/assets/lib/toast.vue